import { render, staticRenderFns } from "./NavBarItem.vue?vue&type=template&id=0030263a&scoped=true&"
import script from "./NavBarItem.vue?vue&type=script&lang=ts&"
export * from "./NavBarItem.vue?vue&type=script&lang=ts&"
import style0 from "./NavBarItem.vue?vue&type=style&index=0&id=0030263a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0030263a",
  null
  
)

export default component.exports